import { IWithChildren } from '@/util/reactTypes';

// Sidebar holds a fixed 300px on desktop (lg+) and stacks below the
// main column on mobile. The previous max-xl:w-40 step collapsed the
// rail to 160px between lg (1024px) and xl (1280px), which made the
// webcam thumbnail and ad slot unreadably narrow — drop that step
// so 300px holds across all desktop widths.
//
// Rail rhythm: spacing used to key off `> article`, which only matched
// the Twitter card (SectionCard as="article"). The featured cam renders
// an <a>, RelatedArticles a <section>, SidebarAd bare <div>s, so those
// sat flush with no gap at all.
//
// space-y rather than a bottom-margin rule, because a rail child can be
// present in the DOM but hidden: SidebarAd's WeSki widget renders under
// `max-md:hidden` when hideWeSkiOnMobile is set. A `:not(:last-child)`
// bottom margin puts the gap on the *preceding* element, so the ad kept
// a trailing margin opening into a hidden div. space-y puts the gap on
// the *following* element instead — a display:none child generates no
// box, so it takes its margin with it and the rail closes up.
const sideClass = [
  'w-[300px] ml-[30px] flex-shrink-0',
  'max-lg:w-auto max-lg:min-w-0 max-lg:ml-0',
  'space-y-8 max-lg:space-y-6',
].join(' ');

export function Side({
  children,
}: { } & IWithChildren) {
  return (
    <aside className={sideClass}>
      {children}
    </aside>
  );
}
